import React from 'react';
import { MailIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SUPPORT_EMAIL } from '../data/content';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="border-b border-line bg-canvasAlt" data-id="element-82" data-mp="9ttjujy9kf2v">
      <div className="mx-auto max-w-2xl px-4 py-9 text-center sm:px-6" data-id="element-83" data-mp="etz59idxx5ci">
        <p className="font-display text-[0.65rem] font-bold uppercase tracking-[0.16em] text-success" data-id="element-84" data-mp="jsir7isjah4v">
          Tu compra está 100% protegida
        </p>

        <Reveal className="mt-3 flex flex-col items-center rounded-2xl border border-success/30 bg-surface p-5" data-id="element-85" data-mp="nst4zhmkibua">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-success-soft" data-id="element-86" data-mp="slmbob1lju90">
            <ShieldCheckIcon size={22} className="text-success" data-id="element-87" data-mp="xj5od6inbyyu" />
          </span>
          <h2 id="garantia" className="mt-3 font-display text-lg font-extrabold uppercase text-ink sm:text-xl" data-id="element-88" data-mp="12kbhh5g7xo8w">
            Garantía total de 7 días
          </h2>
          <p className="mt-1 font-display text-xs font-bold uppercase tracking-wide text-success" data-id="element-89" data-mp="25sq7n0yj0d61">
            Tu dinero está protegido
          </p>
          <p className="mt-3 text-sm leading-relaxed text-ink-muted" data-id="element-90" data-mp="1vtr602c6hhsj">
            Tenés 7 días completos para explorar los 6 tomos, revisar los
            proyectos, conocer los 5 bonos y evaluar el contenido. Si considerás
            que el Mega Pack no cumple con lo ofrecido, podés solicitar la
            devolución del 100% de tu compra.
          </p>
          <p className="mt-2 font-display text-sm font-extrabold uppercase text-ink" data-id="element-91" data-mp="2jjv9m9pd9hjj">
            Cero riesgo para vos
          </p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-volt transition-colors duration-150 ease-soft hover:text-accent" data-id="element-92" data-mp="2ar055i7q3put">
            <MailIcon size={13} data-id="element-93" data-mp="32ho6ovdb6x90" />
            {SUPPORT_EMAIL}
          </a>
        </Reveal>
      </div>
    </section>;
}